import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getSeriesSeasonsByCode } from "@/services/series";
import type { SeriesSeasonsResponse } from "@/types/series";

/**
 * Seasons + episodes for a series, from the dedicated
 * GET /series/by-code/{code}/seasons endpoint. Series detail no longer
 * embeds this data, so anything needing episode uuids (hero "play last
 * episode" button, the Seasons section itself) must go through this query.
 * Both callers share the same cache entry per uniqueCode — only one network
 * request fires even though the hero needs it eagerly and Seasons.tsx only
 * renders once scrolled into view.
 */
export function useSeriesSeasons(uniqueCode) {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== uniqueCode) {
    t0 = ["series-seasons", uniqueCode];
    t1 = () => getSeriesSeasonsByCode(uniqueCode as string);
    $[0] = uniqueCode;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = Boolean(uniqueCode);
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
}